// extracted by mini-css-extract-plugin
export var actions = "_4a-0";
export var actionsContainer = "_4a-6";
export var border = "_4a-1";
export var childFullHeight = "_4a-d";
export var collapse = "_4a-2";
export var content = "_4a-8";
export var contentChild = "_4a-c";
export var fullscreen = "_4a-a";
export var headerContainer = "_4a-3";
export var headerRow = "_4a-5";
export var hidePadding = "_4a-9";
export var noScrollX = "_4a-e";
export var noScrollY = "_4a-f";
export var optOutTopPadding = "_4a-b";
export var pagePadding = "_4a-7";
export var profile = "_4a-g";
export var profileContainer = "_4a-h";
export var profileImage = "_4a-i";
export var profileMain = "_4a-j";
export var profileSubtitle = "_4a-l";
export var profileTitle = "_4a-k";
export var tabsWrapper = "_4a-4";
export var title = "_4a-m";